import { Button, Tabs } from "antd";
import { useState } from "react";
import Icon from "../../../assets/icons/icon";
import _t from "../../../lang/translate";
import { ModelCatalogFilterForm, ModelMatch, SourceVehiclePreview } from "../../../types/motorAtlasCatalogTypes";
import { TaxCase } from "../../../types/taxTypes";
import MotorAtlasCatalogFilters from "./motorAtlasCatalogFilters";
import MotorAtlasCatalogMatches from "./motorAtlasCatalogMatches";
import MotorAtlasCreateCustomVariant from "./motorAtlasCreateCustomVariant";
import MotorAtlasExpandedSearch from "./motorAtlasExpandedSearch";
import { ModelMatcherInputVehicle, SubmitPayload } from "./util";

type Features = "choose-model" | "expanded-search" | "create-variant";

type Props = {
  sourceVehicle: SourceVehiclePreview | null;
  selectedMatch: ModelMatch | null;
  setSelectedMatch: React.Dispatch<React.SetStateAction<ModelMatch | null>>
  inputVehicle: ModelMatcherInputVehicle | null,
  presetFiltersRef: React.MutableRefObject<ModelCatalogFilterForm | undefined>
  submit: (submitPayload: SubmitPayload) => void;
}
export default function MotorAtlasCatalogMapper({ sourceVehicle, selectedMatch, setSelectedMatch, inputVehicle, submit, presetFiltersRef }: Props) {
  const [matches, setMatches] = useState<ModelMatch[] | null>(null)
  const [showCreateCustomVariant, setShowCreateCustomVariant] = useState(false)
  const [expandedMatches, setExpandedMatches] = useState<ModelMatch[] | null>(null)
  const [activeTab, setActiveTab] = useState<Features>("choose-model")
  function addNewModel() {
    setShowCreateCustomVariant(true)
    setActiveTab("create-variant")
  }

  return (
    <Tabs
      activeKey={activeTab}
      onChange={(tab) => setActiveTab(tab as any)}
      tabBarExtraContent={
        <Button onClick={addNewModel} type="text" icon={<Icon name="add-outline" />}>{_t("create")}</Button>
      }
    >
      <Tabs.TabPane forceRender destroyInactiveTabPane={false} tabKey="choose-model" key={"choose-model"}
        tab={_t("choose", "from") + " " + _t("modelCatalog").toLowerCase()}>
        <MotorAtlasCatalogFilters presetFiltersRef={presetFiltersRef} inputVehicle={inputVehicle} setMatches={setMatches} sourceVehicle={sourceVehicle} />
        <MotorAtlasCatalogMatches matches={matches} selectedMatch={selectedMatch} setSelectedMatch={setSelectedMatch} sourceVehicle={sourceVehicle} />
      </Tabs.TabPane>
      <Tabs.TabPane forceRender destroyInactiveTabPane={false} tabKey="expanded-search" key={"expanded-search"}
        tab={_t("expanded")}>
        <MotorAtlasExpandedSearch inputVehicle={inputVehicle} setMatches={setExpandedMatches} sourceVehicle={sourceVehicle} />
        <MotorAtlasCatalogMatches matches={expandedMatches} selectedMatch={selectedMatch} setSelectedMatch={setSelectedMatch} sourceVehicle={sourceVehicle} />
      </Tabs.TabPane>
      {showCreateCustomVariant && (
        <Tabs.TabPane active tabKey="create-model" key={"create-variant"}
          tab={_t("create", "new") + " " + _t("model").toLowerCase()}>
          <MotorAtlasCreateCustomVariant submit={submit} />
        </Tabs.TabPane>
      )}
    </Tabs>
  )
}
